
/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Master.HeaderSubMenu <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 6.6.2023<br />
/// Copyright ©: EUDT GmbH 2023 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 6.6.2023                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.HeaderSubMenu", $.common.VisualBase, {

    _create: function () {
        var me = this;
        try {
           
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 290;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //inits the super class
            me._super();

        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {

            me.showMessage("", false);
            me.visual.css("left", parseInt(me.options.parameter.position.left) - 400 + parseInt(me.options.parameter.btnWidth)).width(me.visual.width());
            me.visual.css("top", parseInt(me.options.parameter.position.top + parseInt(me.options.parameter.btnHeight) + 1));
           
        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
           //add the clickhandler for the language selection and reload the page
            me.fnd("#ddl-lang-id").val(me.specific.userLangidForCulture).off("change").on("change", function () {
                window.VisualCoreService.setLanguage(parseInt($(this).val()), function (result) {

                    if (result === null) {
                        return null;
                    }
                    if (result === true) {
                        window.location = window.location;
                        return false;
                    }
                    return true;
                });
            });

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },



    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                $('#divContent').hide();
            }
            return true;
        } catch (e) {
            me.writeError('_setDirty', e); return false;
        }
    }


});




